import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import { Switch, Route, Redirect } from 'react-router-dom';
// creates a beautiful scrollbar
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

// core components
import AdminNavbar from 'components/Navbars/AdminNavbar';
import Sidebar from 'components/Sidebar/Sidebar';
import DialogManager from 'components/DialogManager/DialogManager';
import FullScreenLoading from 'components/FullScreenLoading/FullScreenLoading';

import routes from 'routes';
import { filterRoutesByUserRole } from 'plugins/router/guards';
import layoutNames from 'utils/enums/layout-names.enum';

import styles from 'assets/jss/material-dashboard-pro-react/layouts/adminStyle';

import image from 'assets/img/sidebar-2.jpg';
import logo from 'assets/img/sevis-logo.svg';

import AuthService from 'services/auth.service';
import { getPortalSettings } from 'services/portal-settings.service';
import { store } from 'plugins/store/store';
import { setAlertActionCreator } from 'plugins/store/reducers/common.reducer';
import { setAutoLockSettingsActionCreator } from 'plugins/store/reducers/auth.reducer';

var ps;

let warnTimeout = null;
let lockTimeout = null;

const clearLockTimeout = () => {
	if (warnTimeout) clearTimeout(warnTimeout);
	if (lockTimeout) clearTimeout(lockTimeout);
};

const useStyles = makeStyles(styles);

const AdminLayout = (props) => {
	const { loading, alert, pageHeaderText, ...rest } = props;
	// states and functions
	const [mobileOpen, setMobileOpen] = React.useState(false);
	const [miniActive, setMiniActive] = React.useState(false);
	let localStorageTriggered = false;
	// const [hasImage, setHasImage] = React.useState(true);
	// styles
	const color = 'red';
	const bgColor = 'black';
	const classes = useStyles();
	const mainPanelClasses =
		classes.mainPanel +
		' ' +
		cx({
			[classes.mainPanelSidebarMini]: miniActive,
			[classes.mainPanelWithPerfectScrollbar]:
				navigator.platform.indexOf('Win') > -1,
		});
	// ref for main panel div
	const mainPanel = React.createRef();

	let autoLock = store.getState().auth.autoLock || {
		warningTimeout: 10800,
		lockTimeout: 10810,
	};

	const events = [
		'load',
		'mousemove',
		'mousedown',
		'click',
		'scroll',
		'keypress',
	];

	let resetTimeoutFromAnotherTab;

	// effect instead of componentDidMount,
	React.useEffect(() => {
		for (var i in events) {
			window.addEventListener(events[i], resetTimeout);
		}

		resetTimeoutFromAnotherTab = () => {
			resetTimeout({ fromAnotherTab: true });
		};
		window.addEventListener('storage', resetTimeoutFromAnotherTab);

		setPortalSettings(resetTimeout);

		return function cleanup() {
			destroy();
		};
	}, []);

	// effect instead of componentDidUpdate and componentWillUnmount
	React.useEffect(() => {
		if (navigator.platform.indexOf('Win') > -1) {
			ps = new PerfectScrollbar(mainPanel.current, {
				suppressScrollX: true,
				suppressScrollY: false,
			});
			document.body.style.overflow = 'hidden';
		}
		window.addEventListener('resize', resizeFunction);

		// Specify how to clean up after this effect:
		return function cleanup() {
			if (navigator.platform.indexOf('Win') > -1) {
				ps.destroy();
			}
			window.removeEventListener('resize', resizeFunction);
		};
	});

	// functions for changeing the states from components
	const handleDrawerToggle = () => {
		setMobileOpen(!mobileOpen);
	};
	const getRoute = () => {
		return window.location.pathname !== `/${layoutNames.portal}/full-screen-maps`;
	};

	// eslint-disable-next-line no-unused-vars
	const getActiveRoute = (routes, parentMatch = null) => {
		let activeRoute = 'Default Brand Text';
		for (let i = 0; i < routes.length; i++) {
			if (routes[i].collapse || routes[i].views?.length) {
				let collapseActiveRoute = getActiveRoute(
					routes[i].views,
					routes[i].path
				);
				if (collapseActiveRoute !== activeRoute) {
					return collapseActiveRoute;
				}
			} else {
				const combinedPath = `${routes[i].layout}${parentMatch || ''}${routes[i].path
					}`
					.split('/')
					.filter((segment) => segment.charAt(0) !== ':')
					.join('/');

				const matched =
					routes[i].path === ''
						? window.location.pathname === combinedPath
						: window.location.pathname.indexOf(combinedPath) !== -1;

				if (matched) {
					return routes[i].name;
				}
			}
		}
		return activeRoute;
	};
	const getRoutes = (routes, parentMatch = null) => {
		return routes.filter(filterRoutesByUserRole).map((prop, key) => {
			if (prop.collapse || prop.views?.length) {
				return getRoutes(prop.views, prop.path);
			}
			if (prop.layout === `/${layoutNames.portal}`) {
				const combinedPath = `${prop.layout}${parentMatch || ''}${prop.path
					}`;

				return (
					<Route
						exact={prop.path === ''}
						path={combinedPath}
						component={prop.component}
						key={key}
					/>
				);
			} else {
				return null;
			}
		});
	};
	const sidebarMinimize = () => {
		setMiniActive(!miniActive);
	};
	const goBack = () => {
		props.history.go(-1);
	};
	const resizeFunction = () => {
		if (window.innerWidth >= 960) {
			setMobileOpen(false);
		}
	};

	const setPortalSettings = async (callback = () => { }) => {
		try {
			const settings = await getPortalSettings();
			const lockWarningTimeoutSetting = settings.filter((item) => item.name === 'autoLogoutNotificationTimeout');
			const lockTimeoutSetting = settings.filter((item) => item.name === 'autoLogoutTimeout');

			if (lockWarningTimeoutSetting.length > 0 && lockTimeoutSetting.length > 0) {
				const lockWarningTimeout = Number(lockWarningTimeoutSetting[0].value);
				const lockTimeout = Number(lockTimeoutSetting[0].value);

				autoLock.warningTimeout = lockWarningTimeout;
				autoLock.lockTimeout = lockTimeout;

				store.dispatch(setAutoLockSettingsActionCreator({
					warningTimeout: lockWarningTimeout,
					lockTimeout: lockTimeout,
				}));
			}
		} catch (error) {
			console.log(error);
		} finally {
			callback();
		}
	};


	const setLockScreenTimeout = () => {
		warnTimeout = setTimeout(warn, autoLock.warningTimeout * 1000);
		lockTimeout = setTimeout(lock, autoLock.lockTimeout * 1000);
	};

	const triggerLocalStorageForResetTimeout = () => {
		if (!localStorageTriggered) {
			localStorageTriggered = true;
			localStorage.setItem('resetTimeout', Date.now());
			setTimeout(() => {
				localStorageTriggered = false;
			}, autoLock.warningTimeout * 1000 * 0.5);
		}
	};

	const resetTimeout = ({ fromAnotherTab } = {}) => {
		if (!fromAnotherTab) {
			triggerLocalStorageForResetTimeout();
		}
		clearLockTimeout();
		setLockScreenTimeout();
	};

	const warn = () => {
		store.dispatch(
			setAlertActionCreator({
				type: 'info',
				title: 'Auto Lock Warning',
				message:
					"We didn't discover any activity from you for a while. You session will be closed soon",
				confirmBtnText: 'Keep Alive',
				onConfirm: () => {
					store.dispatch(setAlertActionCreator(null));
				},
			})
		);
	};

	const lock = () => {
		destroy();
		AuthService.logout();
		props.history.push(`/${layoutNames.auth}/login`);
	};

	const destroy = () => {
		clearLockTimeout();
		store.dispatch(setAlertActionCreator(null));

		for (var i in events) {
			window.removeEventListener(events[i], resetTimeout);
		}
		window.removeEventListener('storage', resetTimeoutFromAnotherTab);
	};

	return (
		<div className={classes.wrapper}>
			{loading && <FullScreenLoading />}
			<Sidebar
				routes={routes}
				logoTextLine1={'eCallMe!'}
				logoTextLine2={'License Portal'}
				logo={logo}
				image={image}
				handleDrawerToggle={handleDrawerToggle}
				open={mobileOpen}
				color={color}
				bgColor={bgColor}
				miniActive={miniActive}
				{...rest}
			/>
			<div className={`with-perfect-scroll-bar ${mainPanelClasses}`} ref={mainPanel}>
				<AdminNavbar
					sidebarMinimize={sidebarMinimize.bind(this)}
					miniActive={miniActive}
					brandText={pageHeaderText || ''}
					handleDrawerToggle={handleDrawerToggle}
					goBack={goBack}
					{...rest}
				/>
				{/* On the /maps/full-screen-maps route we want the map to be on full screen - this is not possible if the content and container classes are present because they have some paddings which would make the map smaller */}
				{getRoute() ? (
					<div className={classes.content}>
						<div className={classes.container}>
							<Switch>
								{getRoutes(routes)}
								<Redirect from={`/${layoutNames.portal}`} to="/home" />
							</Switch>
						</div>
					</div>
				) : (
						<div className={classes.map}>
							<Switch>
								{getRoutes(routes)}
								<Redirect from={`/${layoutNames.portal}`} to="/home" />
							</Switch>
						</div>
					)}
			</div>
			{alert && (
				<DialogManager
					type={alert.type}
					title={alert.title}
					message={alert.message}
					children={alert.children}
					disabled={alert.disabled}
					onConfirm={alert.onConfirm}
					onCancel={alert.onCancel}
					confirmBtnText={alert.confirmBtnText}
					cancelBtnText={alert.cancelBtnText}
					showIcon={alert.showIcon}
					maxWidth={alert.maxWidth}
					confirmBtnColor={alert.confirmBtnColor}
					cancelBtnColor={alert.cancelBtnColor}
				/>
			)}
		</div>
	);
};

const mapStateToProps = ({
	common: { loading, alert, pageHeaderText },
	...props
}) => {
	return {
		...props,
		loading,
		alert,
		pageHeaderText,
	};
};

export default connect(mapStateToProps)(AdminLayout);
